module.exports = __webpack_public_path__ + "img/Intro_3_1.d26d5f57.gif";